import React from 'react';
import useCheckout from './use-checkout';
import { useDispatch } from 'react-redux';
import { setShippingMethod } from 'services/ecommerce';
import { BodySection, BodySectionTitle } from '../sharedStyles';
import StripeAddress from 'components/ui/v2/Inputs/Address';
import { useAdminTranslation } from 'hooks/use-translation';
import { StripeAddressElementChangeEvent } from '@stripe/stripe-js';
import { IAddress } from 'services/account-address';
import { setBillingInfo } from 'services/billing';
import useStripeContacts from 'hooks/use-stripe-contacts';

const CheckoutBillingAddress = () => {
  const { shopifyPaymentProcessing } = useCheckout();
  const { contacts, loading } = useStripeContacts();
  const dispatch = useDispatch();
  const { t } = useAdminTranslation();

  const handleAddressChange = (event: StripeAddressElementChangeEvent) => {
    const value = event?.value;
    if (!value) {
      return;
    }

    // in order to clear preselected shipping method
    dispatch(setShippingMethod(''));

    const name = value.name || '';
    const address = value.address || {};
    const phone = value.phone || '';

    const nameParts = name.split(' ');
    const firstName = nameParts[0];
    const lastName = nameParts[nameParts.length - 1];

    const addressBase: IAddress = {
      address1: address.line1,
      address2: address.line2 || '',
      countryCode: address.country,
      postalCode: address.postal_code,
      state: address.state,
      firstName,
      lastName,
      city: address.city,
      phoneNumber: phone,
      complete: true,
    };

    dispatch(setBillingInfo({
      complete: true,
      countryCode: addressBase.countryCode,
      postalCode: addressBase.postalCode,
      address: addressBase.address1,
      city: addressBase.city,
      stateCode: addressBase.state,
      markDefaultPaymentMethod: false,
      name,
      error: null,
      phone: addressBase.phoneNumber,
    }));
  };

  if (loading) {
    return null;
  }

  return (
    <BodySection shopifyPaymentProcessing={shopifyPaymentProcessing}>
      <BodySectionTitle>{t('LABEL_BILLING_ADDRESS')}</BodySectionTitle>
      <StripeAddress
        onChange={handleAddressChange}
        contacts={contacts}
        mode="billing"
        validation={{
          phone: {
            required: 'always',
          },
        }}
      />
    </BodySection>
  );
};

export default CheckoutBillingAddress;
